import React from 'react';

const extractSrc = (url) => {
  if (!url || typeof url !== 'string') {
    return url;
  }

  const match: RegExpMatchArray = url.match(/<iframe[^>]+src=["']([^"']+)["']/i);
  return match ? match[1] : url;
};

const VideoPlayer = ({ url }) => {
  const resolvedUrl = extractSrc(url);

  return (
    <div style={{ position: 'relative', paddingTop: '20%', width: '100%' }}>
      <iframe
        src={resolvedUrl}
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
        frameBorder="0"
        allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
        allowFullScreen
      />
    </div>
  );
};

export default VideoPlayer;
